import dayjs from "dayjs";
import type { DataMap } from "src/Modules/UserHistory/pages/OrdersList/components/OrderCard/constants";
import { formatNumber } from "src/utility";
import i18n from "src/i18n";

export const pointsExchangeHeaderDataMap: DataMap = {
  referenceNumber: {
    get label() {
      return i18n.t("UserHistory.orderDetails.orderId");
    },
    value: (val) => <div className="@container">{val}</div>,
  },
  orderedAt: {
    get label() {
      return i18n.t("UserHistory.ordersList.exchangeDate");
    },
    value: (val) => <div>{dayjs(val).format("DD/MM/YYYY")}</div>,
  },
};

export const pointsExchangeGridDataMap: DataMap = {
  total: {
    get label() {
      return i18n.t("UserHistory.orderDetails.sourcePoints");
    },
    value: (val) => (
      <div className="flex items-center gap-1 text-font-danger">
        <div className="font-semibold">-</div>
        <div className="font-bold">{formatNumber(val)}</div>
      </div>
    ),
  },
  conversionRatio: {
    get label() {
      return i18n.t("UserHistory.orderDetails.conversionRatio");
    },
    value: (val) => {
      return `${formatNumber(1)} ${i18n.t("UserHistory.orderDetails.points")} = ${formatNumber(val?.to / val?.from)}`;
    },
  },
  destinationPoints: {
    get label() {
      return i18n.t("UserHistory.orderDetails.destinationPoints");
    },
    value: (val) => (
      <div className="text-font-success flex items-center gap-1">
        <div className="font-semibold">+</div>
        <div className="font-bold">{formatNumber(val)}</div>
      </div>
    ),
  },
};
